const SIDE_BAR_LINKS = {
  LABORATORY_MASTER: [
    "/investigation-test",
    "/investigation-template",
    "/package-investigation",
    "/investigation-observation",
    "/investigation-sequence",
    "/investigation-nabl",
    "/investigation-deliveryDays",
  ],
  LABORATORY: ["/patient-wise-search-report"],
  SAMPLE_COLLECTION: ["/sample-collection"],
  EMPLOYEE: ["/employee"],
  FRANCHISE_MASTER: ["/registration", "/camp-bulk-booking", "/patient", "/panel-master", "/franchise-onboarding", "/pending-onboarding"],
  FRONT_OFFICE: [
    "/doctors",
    "/patient",
    "/estimate",
    "/registration",
    "/camp-bulk-booking",
    "/test-rate-list-excel",
  ],
  ADMINISTRATOR: [
    "/lab-department",
    "/investigation-interpretation",
    "/investigation-comment",
    "/investigation-deliveryDays",
    "/investigation-manager",
    "/investigation-template",
    "/area",
    "/collection-type",
    "/circular",
    "/designation",
    "/emp-discount-allowed",
    "/discount-reason",
    "/doctors",
    "/document",
    "/employee",
    "/panel-master",
    "/outsource-lab",
    "/franchise",
    "/franchise-onboarding",
    "/pending-onboarding",
    "/roles",
    "/sections",
    "/sampleRejectionReason",
    "/sampleType",
    "/patient-appointment-details",
    "/panne-wise-bus-report",
    "/patient-wise-search-report",
    "/audit-logs",
  ],
  ACCOUNT: ["/patient-wise-search-report", "/payment-type-search-report"],
  PANEL: ["/franchise"],
  BILLING: [
    "/patient",
    "/panne-wise-bus-report",
    "/payment-type-search-report",
    "/patient-appointment-details",
  ],
  DOC_ACCOUNT: [
    "/patient",
    "/panne-wise-bus-report",
    "/payment-type-search-report",
    "/patient-appointment-details",
  ],
  EDP: [
    "/lab-department",
    "/investigation-interpretation",
    "/investigation-comment",
    "/investigation-deliveryDays",
    "/investigation-manager",
    "/investigation-template",
    "/area",
    "/collection-type",
    "/circular",
    "/designation",
    "/emp-discount-allowed",
    "/discount-reason",
    "/doctors",
    "/employee",
    "/panel-master",
    "/outsource-lab",
    "/franchise",
    "/franchise-onboarding",
    "/pending-onboarding",
    "/roles",
    "/sections",
    "/sampleRejectionReason",
    "/sampleType",
    "/panne-wise-bus-report",
  ],
  SUPER_FRANCHISE_MASTER: [
    "/commission-report",
    "/patient-wise-search-report",
    "/franchise",
    "/panel-master",
    "/estimate",
    "/panne-wise-bus-report",
  ],
  RADIOLOGY: ["/patient-wise-search-report"],
  SUBPCC: ["/patient-wise-search-report", "/panne-wise-bus-report"],
  STORE: [],
  DISPATCH: [],
};

export default SIDE_BAR_LINKS;
